<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 公章申请管理 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <div style="width:1200px">
                    <el-form :model="query" ref="query" label-width="130px" inline="">
                        <el-form-item label="公司名称:">
                            <el-input
                                v-model="query.company_name"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址:">
                            <el-input
                                v-model="query.company_address"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="统一社会信用代码:">
                            <el-input
                                v-model="query.credit_code"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="法人:">
                            <el-input
                                v-model="query.legal_person"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="法人身份证:">
                            <el-input
                                v-model="query.identification"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话:">
                            <el-input
                                v-model="query.userTel"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="公司类型:">
                            <el-input
                                v-model="query.address_type"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="订单状态:">
                            <el-select v-model="query.status" placeholder="请输入" class="handle-input mr10" @change="inputSearch()">
                                <el-option v-for="item in statuslist" :label="item.label" :key="item.id" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收件人:">
                            <el-input
                                v-model="query.recipient"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="备注:">
                            <el-input
                                v-model="query.remark"
                                placeholder="请输入"
                                class="handle-input mr10"
                                @input="inputSearch()"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="申请时间:">
                            <el-date-picker
                                class="data"
                                type="date"
                                placeholder="起始日期"
                                v-model="query.start_time"
                                style="width: 150px;padding-right:5px"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="inputSearch()"
                            ></el-date-picker>
                            <span>-</span>
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                class="data"
                                type="date"
                                placeholder="结束日期"
                                v-model="query.end_time"
                                style="width: 150px;padding-right:10px;padding-left:5px"
                                @change="inputSearch()"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="付款时间:">
                            <el-date-picker
                                class="data"
                                type="date"
                                placeholder="起始日期"
                                v-model="payTime.start_time"
                                style="width: 150px;padding-right:5px"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="inputSearch()"
                            ></el-date-picker>
                            <span>-</span>
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                class="data"
                                type="date"
                                placeholder="结束日期"
                                v-model="payTime.end_time"
                                style="width: 150px;padding-right:10px;padding-left:5px"
                                @change="inputSearch()"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="buttonBar">
                        <div>
                            <el-button style="margin-left:30px" type="primary" icon="el-icon-search" @click="getData()"> 搜索</el-button>
                            <el-button type="primary" @click="resetsearch()">重置</el-button>
                            <el-button type="success" @click="exportTableVisiable = true">导出报表</el-button>
                        </div>
                        <div class="elTag" v-if="paysumloding">
                            <el-tag size="medium">实付总金额: {{ pay_sum }}</el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                class="table1"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
                :header-cell-style="{ 'text-align': 'center' }"
            >
                <el-table-column prop="numbering" label="单号" width="170" align="center" fixed></el-table-column>
                <el-table-column prop="company_name" label="公司名称" width="150" align="center"></el-table-column>
                <el-table-column prop="legal_person" label="经办人" width="80" align="center"></el-table-column>
                <el-table-column prop="userTel" label="联系电话" width="115" align="center"></el-table-column>
                <el-table-column prop="pay" label="实付金额" width="80" align="center">
                    <template slot-scope="scope">
                        <span style="color: #e1684c;">{{ scope.row.pay }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="total" label="订单金额" width="80" align="center"></el-table-column>
                <el-table-column label="订单状态" align="center" width="105">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color:rgb(242, 94, 67)">待付款</span>
                        <span v-else-if="scope.row.status == 2" style="color:rgb(236, 160,70)">已受理</span>
                        <span v-else-if="scope.row.status == 3" style="color:rgb(22,162,51)">待确认</span>
                        <span v-else-if="scope.row.status == 4" style="color:rgb(22,162,251)">已完成</span>
                        <span @click="tuikuan(scope.$index, scope.row)" v-else-if="scope.row.status == 5" style="color:red"
                            >申请退款 （点击处理）</span
                        >
                        <span v-else-if="scope.row.status == 6" style="color:red">退款失败</span>
                        <span v-else-if="scope.row.status == 7" style="color:red">已退款</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="forward_openid" label="付款方式">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.forward_openid != null">代付</el-tag>
                        <el-tag type="success" v-if="scope.row.forward_openid == null">微信</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="recipient" label="收件人" width="80" align="center"></el-table-column>
                <el-table-column prop="application_time" label="申请时间" width="100" align="center"></el-table-column>
                <el-table-column align="center" prop="pay_time" label="付款时间" width="100"></el-table-column>
                <el-table-column label="类型" align="center" width="105">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="comyname" placement="top">
                            <span v-if="scope.row.type == 1" @mouseenter="getcomyname(1, companyid)">公司</span>
                            <span v-else @mouseenter="getcomyname(2, scope.row.type)">财务公司</span>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column prop="note" label="特殊备注" width="140" align="center">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.note" placement="top">
                            <div slot="content">
                                <div style="width:200px;height:auto">
                                    {{ scope.row.note }}
                                </div>
                            </div>
                            <div class="typeEnter">{{ scope.row.note }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="配送方式">
                    <template slot-scope="scope">
                        <div>
                            <el-tag v-if="scope.row.distribution == '0'">
                                送
                            </el-tag>
                            <el-tag type="danger" v-if="scope.row.distribution == '1'">
                                寄
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="255" align="left">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" content="删除" placement="top" v-if="$store.state.roleid != 5">
                            <img
                                class="iconPic"
                                src="../../../assets/img/shanchu.png"
                                alt=""
                                @click="handleDelete(scope.$index, scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="编辑" placement="top">
                            <img
                                class="iconPic1"
                                src="../../../assets/img/bianji.png"
                                alt=""
                                @click="handleEdit(scope.$index, scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="打印" placement="top">
                            <img class="iconPic" src="../../../assets/img/dayin.png" alt="" @click="printwindow(scope.$index, scope.row)" />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="填写印章编号" placement="top">
                            <img
                                class="iconPic"
                                src="../../../assets/img/xinxitianxie.png"
                                alt=""
                                @click="sealnumber(scope.$index, scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="查看申请材料" placement="top">
                            <img class="iconPic" src="../../../assets/img/more.png" alt="" @click="applyDoc(scope.$index, scope.row)" />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="发货" placement="top">
                            <img
                                v-if="scope.row.status == 2"
                                class="iconPic"
                                src="../../../assets/img/send.png"
                                alt=""
                                @click="sendGoods(scope.$index, scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip effect="dark" content="修改订单价格" placement="top" v-if="$store.state.roleid != 5">
                            <img
                                v-if="scope.row.status == 1"
                                class="iconPic"
                                src="../../../assets/img/xiugaijiage.png"
                                alt=""
                                @click="editPrice(scope.$index, scope.row)"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加弹出框 -->
        <el-dialog title="添加公章形状" :visible.sync="addVisiable" width="1200px">
            <head>
                <meta charset="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <!-- 上述3个meta标签*必须*放在最前面，任何其他内容都*必须*跟随其后！ -->
                <title>打印</title>
                <!-- Bootstrap -->
                <meta charset="utf-8" />
                <!-- <link rel="stylesheet" href="css.css"> -->
                <!-- HTML5 shim and Respond.js for IE8 support of HTML5 elements and media queries -->
                <!-- WARNING: Respond.js doesn't work if you view the page via file:// -->
                <!--[if lt IE 9]>
                < src="https://cdn.bootcss.com/html5shiv/3.7.3/html5shiv.min.js"></>
                < src="https://cdn.bootcss.com/respond.js/1.4.2/respond.min.js"></>
                <![endif]-->
            </head>
            <el-button style="margin:0 42px" @click="preview()">打印表格</el-button>
            <!-- <a class="printa" href="javascript:;" onclick="preview1();">打印公章备案表</a>  -->
            <!--startprint-->
            <div id="printme" ref="printme">
                <div
                    class="container a4-endwise"
                    id="test"
                    style="page-break-after:always; width: 1075px;
                height: 1550px;
                overflow: hidden;
                padding: 0;
                word-break: break-all;
                box-sizing: border-box;
                padding: 20px;
                margin: 0 auto;
                "
                >
                    <div style="display:flex">
                        <div style="height:1000px;padding:180px 0px 0 0px;display:flex">
                            <div style="height:800px;border-left:1px dotted black;margin-right:20px;">
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px;">装</div>
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px">订</div>
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px">线</div>
                            </div>
                        </div>
                        <div>
                            <p
                                style="margin-right: 10px;
                    font-size: 38px;
                    text-align: center;
                    font-weight: bold;"
                            >
                                厦门市印章刻制申请登记表
                            </p>
                            <p class="codeline">编码：{{ addForm.numbering }}</p>
                            <div
                                style=" margin: 0 auto;
                 border: 1px solid #333; "
                            >
                                <div
                                    style="height: 60px;
               
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px;  line-height: 60px;text-align: center; border-right: 1px solid #333;">
                                        单位名称
                                    </div>
                                    <div style="width: 324px;padding: 0px 10px;border-right: 1px solid #333;line-height:30px">
                                        {{ addForm.company_name }}
                                    </div>
                                    <div style="width: 160px; line-height: 60px;text-align: center; border-right: 1px solid #333;">
                                        英文名称
                                    </div>
                                    <div style="width: 324px;padding: 0 10px;"></div>
                                </div>
                                <div
                                    style="height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">单位类型</div>
                                    <div style="width: 324px;padding: 0 10px;border-right: 1px solid #333;line-height:60px">
                                        02
                                    </div>
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">成立时间</div>
                                    <div style="width: 324px;padding: 0 10px;">{{ addForm.established }}</div>
                                </div>
                                <div
                                    style="height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">
                                        <span class="topheight">统一社会信用代码</span>
                                    </div>
                                    <div style="width: 324px;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.credit_code }}
                                    </div>
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">联系电话</div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.userTel }}
                                    </div>
                                </div>
                                <div
                                    style="height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">法定代表人</div>
                                    <div style="width: 324px;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.legal_person }}
                                    </div>
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">身份证号码</div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.identification }}
                                    </div>
                                </div>
                                <div
                                    style="height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">单位地址</div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.company_address }}
                                    </div>
                                </div>
                                <div
                                    style=" height: 60px;
                line-height: 60px;
                border-bottom: 1px solid #333;"
                                >
                                    <div
                                        style="text-align: center; width: 100%;
                    font-size: 21px;"
                                    >
                                        申请刻制印章列表
                                    </div>
                                </div>
                                <div
                                    style="  height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                >
                                    <div style="width:160px; border-right: 1px solid #333;">印章名称</div>

                                    <div style="border-right: 1px solid #333;flex: 1;">印章材质</div>
                                    <div style="border-right: 1px solid #333;flex: 1;">印章形状</div>
                                    <div style="border-right: 1px solid #333;flex: 1;">印章数量</div>
                                </div>

                                <div id="box">
                                    <div
                                        v-for="(item, index) in sealTabeldata"
                                        :key="index"
                                        style="  height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                    >
                                        <div style="width:160px; border-right: 1px solid #333;">{{ item.seal_name }}</div>

                                        <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_material }}</div>
                                        <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_shape }}</div>
                                        <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_num }}</div>
                                    </div>
                                </div>
                                <div
                                    style="  height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                >
                                    <div style="width:160px; border-right: 1px solid #333;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                </div>
                                <div
                                    style="  height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                >
                                    <div style="width:160px; border-right: 1px solid #333;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                    <div style="border-right: 1px solid #333;flex: 1;"></div>
                                </div>
                                <div
                                    style="height: 200px;
                border-bottom: 1px solid #333;display: flex;"
                                >
                                    <div
                                        style="  width: 160px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 19px;
                    text-align: center;
                    border-right:1px solid #333;"
                                    >
                                        申请<br />理由
                                    </div>
                                    <div
                                        style=" width: 100%;
                    flex: 1;
                    position: relative;"
                                    >
                                        <div style="padding-top: 10px;padding: 0 10px; font-size: 19px;">
                                            {{ addForm.application }}
                                        </div>
                                        <div
                                            style=" width: 100%;
                        position: absolute;
                        bottom: 0;
                        left:0;
                        box-sizing:  display: flex; "
                                        >
                                            <p
                                                style=" display: block;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px; font-size: 19px;
                        float:left ;padding-left:20px
                        "
                                            >
                                                经办人（申请人）签名：
                                            </p>
                                            <p
                                                style=" display: block;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px; font-size: 19px;
                            float:right;padding-right:20px"
                                            >
                                                <span style="  padding: 0 15px;"></span>{{ dateTime.split('-')[0] }}年<span
                                                    style="  padding: 0 5px;"
                                                ></span
                                                >{{ dateTime.split('-')[1] }}月<span style="padding: 0 5px;"></span
                                                >{{ dateTime.split('-')[2] }}日
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style=" height: 60px;
                    line-height: 60px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">
                                        经办人身份证号码
                                    </div>
                                    <div style="padding: 0 10px; ">{{ addForm.identification }}</div>
                                </div>
                                <div
                                    style=" height: 60px;
                    line-height: 60px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">经办人联系方式</div>
                                    <div style="padding: 0 10px; ">{{ addForm.userTel }}</div>
                                </div>
                                <div
                                    style=" height: 60px;
                    line-height: 60px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 160px; text-align: center; border-right: 1px solid #333;">刻章企业名称</div>
                                    <div style="padding: 0 10px; ">{{ printData.company_name }}</div>
                                </div>
                                <div style=" display: flex;">
                                    <div
                                        style=" width: 160px;
                    align-items: center;
                    text-align: center;
                    justify-content: center;
                    height: 180px;   
                    border-right: 1px solid #333; 
                    text-align: center;
                    display: flex;
                    font-size:19px "
                                    >
                                        备注
                                    </div>
                                    <div style="padding: 0 10px;font-size:19px">
                                        1.印章类型：法定名称章、内设机构章、分支机构章；财务章、合同章、发票章等单位专用章、
                                        <br />
                                        2.单位类型：党政机关、人大、政协、部队填写（01），企业单位填写（02），事业单位填写填写（03），社会团体填写（04），民办非企业单位填写（05），其它填写（06）
                                        <br />
                                        3.印章材质有：铜、回墨、光敏、木头、钢、玉等。
                                        <br />
                                        4.申请理由：首次刻章，遗失重新刻章，被盗重新刻章、损坏重新刻章、更名重新刻章
                                        <br />
                                        5.请用钢笔、水笔或电脑打印填写
                                    </div>
                                </div>
                            </div>
                            <p style=" font-size: 19px;margin-top: 10px;  display: flex;">
                                <span style="flex: 1;">填表日期:</span><span style="  float: right;">(请用钢笔，水笔填写)</span>
                            </p>
                        </div>
                    </div>
                </div>
                <!---重要刻件登记-->
                <!--style="page-break-after:always" 表示添加分页功能  -->
                <div
                    class="container  "
                    id="test"
                    style="page-break-after:always;   height: 1550px;
            width:  1075px;
            overflow: hidden;
            box-sizing: border-box;
            padding: 20px;
            margin: 0 auto;"
                >
                    <div style="margin-top:30px;transform: rotate(90deg);">
                        <p
                            style="margin-top: 30px;
                    font-size: 38px;
                    text-align: center;
                    font-weight: bold;
                    padding-left:350px"
                        >
                            印章业重要刻件登记薄
                        </p>
                        <div style="display:flex;width:1450px; justify-content: space-between;">
                            <p style=" font-size: 20px;">公司名称：{{ addForm.company_name }}</p>
                            <p class="codeline">编码：{{ addForm.numbering }}</p>
                        </div>

                        <div style="margin:0;border: 1px solid #333;width:1450px">
                            <div
                                style=" height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                            >
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;">公安机关批文字号</div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;">公安机关批文字号</div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;">公安机关批文字号</div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;">公安机关批文字号</div>
                                <div style=" width: 300px;text-align: center;border-right: 1px solid #333;">备注</div>
                            </div>
                            <div
                                style=" height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;"
                            >
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;  border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;  border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;  border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;  border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 300px;text-align: center;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style="  height: 300px;
                    line-height: 45px;
                    display: flex;
                    font-size: 19px;
                   "
                            >
                                <div
                                    style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;"
                                ></div>
                                <div
                                    style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;"
                                ></div>
                                <div
                                    style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;"
                                ></div>
                                <div
                                    style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;"
                                ></div>
                                <div style=" width: 300px;text-align: center;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style=" height: 50px;
                line-height: 50pxnpm;
                display: flex;
                font-size: 19px;
                "
                            >
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;border-bottom: 1px solid #333;">
                                    刻件样式
                                </div>
                                <div style=" width: 300px;text-align: center;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style="  height: 300px;
                line-height: 45px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                            >
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;"></div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;"></div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;"></div>
                                <div style=" width: 500px;text-align: center;border-right: 1px solid #333;"></div>
                                <div style=" width: 300px;text-align: center;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style=" height: 42px;
                    line-height: 45px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                            >
                                <div style=" width: 1000px;border-right: 1px solid #333;">
                                    <span style="padding:10px">
                                        领章时间：<span style="  padding: 0 15px;"></span>{{ dateTime.split('-')[0] }}年<span
                                            style="  padding: 0 5px;"
                                        ></span
                                        >{{ dateTime.split('-')[1] }}月<span style="padding: 0 5px;"></span>{{ dateTime.split('-')[2] }}日
                                    </span>
                                </div>
                                <div style=" width: 1000px;border-right: 1px solid #333;">
                                    <span style="padding:10px">
                                        领章人（签名）：
                                    </span>
                                </div>
                                <div style="width:300px;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style=" height: 42px;
                line-height: 45px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                            >
                                <div style=" width: 1000px;border-right: 1px solid #333;">
                                    <span style="padding:10px"> 身份证号码（必填）：{{ addForm.identification }} </span>
                                </div>
                                <div style=" width: 1000px;border-right: 1px solid #333;">
                                    <span style="padding:10px"> 联系电话（必填）：{{ addForm.userTel }} </span>
                                </div>
                                <div style="width:300px;border-right: 1px solid #333;"></div>
                            </div>
                            <div
                                style=" height: 60px;
                line-height: 60px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                            >
                                <div style="width:2000px;border-right: 1px solid #333;">
                                    <span style="padding:10px"> 身份证住址（必填）：{{ addForm.card_address }} </span>
                                </div>
                                <div style="width:300px;border-right: 1px solid #333;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!---销毁登记表-->
                <!--style="page-break-after:always" 表示添加分页功能  -->
                <div
                    class="container a4-endwise"
                    id="test"
                    style="page-break-after:always; width: 1075px;
                height: 1550px;
                overflow: hidden;
                padding: 0;
                word-break: break-all;
                box-sizing: border-box;
                padding: 20px;
                margin: 0 auto;"
                >
                    <div style="display:flex">
                        <div style="height:1000px;padding:150px 0px 0 0px;display:flex">
                            <div style="height:800px;border-left:1px dotted black;margin-right:20px;">
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px;">装</div>
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px">订</div>
                                <div style="font-size:20px;font-weight:bold;margin:0 0 150px -10px">线</div>
                            </div>
                        </div>
                        <div>
                            <p
                                style="margin-top: 5px;
                    font-size: 38px;
                    text-align: center;
                    font-weight: bold;"
                            >
                                厦门市旧公章销毁登记表
                            </p>
                            <div
                                style=" margin: 0 auto;
                 border: 1px solid #333; "
                            >
                                <div
                                    style="height: 50px;
                    line-height: 50px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 340px; text-align: center; border-right: 1px solid #333;">
                                        上缴公章单位名称
                                    </div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.company_name }}
                                    </div>
                                </div>
                                <div
                                    style="height: 50px;
                    line-height: 50px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 340px; text-align: center; border-right: 1px solid #333;">
                                        单位统一社会信用代码
                                    </div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.credit_code }}
                                    </div>
                                </div>
                                <div
                                    style="height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;"
                                >
                                    <div style="flex:1;display: flex;">
                                        <div style="width: 300px; text-align: center; border-right: 1px solid #333;">
                                            法定代表人
                                        </div>
                                        <div style="flex: 1;text-align: center;border-right: 1px solid #333;">
                                            {{ addForm.legal_person }}
                                        </div>
                                    </div>
                                    <div style="flex:1;display: flex;">
                                        <div style="flex: 1; text-align: center; border-right: 1px solid #333; ">联系电话</div>
                                        <div style="flex: 1;text-align: center;border-right: 1px solid #333;">
                                            {{ addForm.userTel }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style="height: 50px;
                    line-height: 50px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333;"
                                >
                                    <div style="width: 300px; text-align: center; border-right: 1px solid #333;">身份证号码</div>
                                    <div style="flex: 1;padding: 0 10px;border-right: 1px solid #333;">
                                        {{ addForm.identification }}
                                    </div>
                                </div>
                                <div
                                    style="  height: 45px;
                line-height: 45px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                >
                                    <div style="flex:1;display: flex;">
                                        <div style="width:300px; border-right: 1px solid #333;">公章名称</div>
                                        <div style="border-right: 1px solid #333;flex: 1;">公章材质</div>
                                    </div>
                                    <div style="flex:1;display: flex;">
                                        <div style="border-right: 1px solid #333;flex: 1;">公章形状</div>
                                        <div style="border-right: 1px solid #333;flex: 1;">公章数量</div>
                                    </div>
                                </div>

                                <div id="box">
                                    <div
                                        v-for="(item, index) in sealTabeldata"
                                        :key="index"
                                        style="  height: 50px;
                    line-height: 50px;
                    display: flex;
                    font-size: 19px;
                    border-bottom: 1px solid #333; text-align: center;"
                                    >
                                        <div style="flex:1;display: flex;">
                                            <div style="width:300px; border-right: 1px solid #333;">{{ item.seal_name }}</div>
                                            <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_material }}</div>
                                        </div>
                                        <div style="flex:1;display: flex;">
                                            <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_shape }}</div>
                                            <div style="border-right: 1px solid #333;flex: 1;">{{ item.chapter_num }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style="height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333;
                text-align:center"
                                >
                                    <div style="flex:1;display: flex;">
                                        <div style="width: 300px; text-align: center; border-right: 1px solid #333;">
                                            上缴公章是否销毁
                                        </div>
                                        <div style="flex: 1;border-right: 1px solid #333;">
                                            <div
                                                style="display:inline-block;border:1px solid black;height:15px;width:15px;margin-left:15px"
                                            >
                                                <div
                                                    style="height:10px;width:5px;border-bottom: 1px solid black;
                            border-right: 1px solid black;webkit-transform: rotate(45deg);margin-left:5px;
                            -moz-transform: rotate(45deg);
                            transform: rotate(45deg)"
                                                ></div>
                                            </div>

                                            <span style="display:inline-block">是</span>
                                            <div
                                                style="height:15px;width:15px;border:1px solid black;margin-left:20px;display:inline-block"
                                            ></div>
                                            <span style="display:inline-block">否</span>
                                        </div>
                                    </div>
                                    <div style="flex:1;display: flex;">
                                        <div style="flex: 1; text-align: center; border-right: 1px solid #333;">销毁原因</div>
                                        <div style="flex: 1;border-right: 1px solid #333;">{{ addForm.application }}</div>
                                    </div>
                                </div>
                                <div
                                    style="  height: 50px;
                line-height: 50px;
                display: flex;
                font-size: 19px;
                border-bottom: 1px solid #333; text-align: center;"
                                >
                                    <div style="border-right: 1px solid #333;flex: 1;">新启用印章印模</div>
                                    <div style="border-right: 1px solid #333;flex: 1;">销毁印章印模</div>
                                </div>
                                <div
                                    style="height: 550px;
                border-bottom: 1px solid #333;display: flex;"
                                >
                                    <div
                                        style=" 
                    flex:1
                    justify-content: center;
                    align-items: center;
                    font-size: 19px;
                    text-align: center;
                    border-right:1px solid #333;"
                                    ></div>
                                    <div
                                        style=" 
                    flex:1
                    justify-content: center;
                    align-items: center;
                    font-size: 19px;
                    text-align: center;
                    border-right:1px solid #333;"
                                    ></div>
                                </div>
                                <div
                                    style="height: 220px;
                border-bottom: 1px solid #333;display: flex;"
                                >
                                    <div
                                        style=" 
                    flex:1
                    font-size: 19px;
                    border-right:1px solid #333;height:220px;line-height:60px"
                                    >
                                        <div style=" font-size: 19px;margin-left:15px">上缴公章单位经办人签名：</div>
                                        <div style=" font-size: 19px;margin-left:15px">身份证号码：{{ addForm.identification }}</div>
                                        <div style=" font-size: 19px;margin-left:15px">联系电话：{{ addForm.userTel }}</div>
                                    </div>
                                    <div
                                        style=" 
                    flex:1
                    font-size: 19px;
                    border-right:1px solid #333;"
                                    >
                                        <div style=" font-size: 19px;margin-left:15px;margin-top:60px">公章刻制企业(签名并盖章：)</div>

                                        <div style=" font-size: 19px;margin-left:15px;margin-top:60px;margin-right:40px;float:right">
                                            <span style="  padding: 0 15px;"></span>{{ dateTime.split('-')[0] }}年<span
                                                style="  padding: 0 5px;"
                                            ></span
                                            >{{ dateTime.split('-')[1] }}月<span style="padding: 0 5px;"></span
                                            >{{ dateTime.split('-')[2] }}日
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;">
                                    <div
                                        style=" width: 170px;
                    align-items: center;
                    text-align: center;
                    justify-content: center;
                    height: 80px;   
                    border-right: 1px solid #333; 
                    text-align: center;
                    display: flex;
                    font-size:19px "
                                    >
                                        备注：
                                    </div>
                                    <div style="padding: 0 10px;font-size:19px">
                                        1.公章类型：法定名称章、内设机构章、分支机构章；财务章、合同章、发票章等单位专用章、
                                        <br />
                                        2.公章材质：铜、圆墨、光敏、木头、玉等
                                    </div>
                                </div>
                            </div>
                            <p style=" font-size: 19px;margin-top: 10px;  display: flex;">
                                <span style="flex: 1;">填表日期:</span><span style="  float: right;">(请用钢笔，水笔填写)</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑公章申请" :visible.sync="editVisible" width="900px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="150px" :inline="true">
                <el-form-item label="公司名称" prop="company_name">
                    <el-input v-model="editForm.company_name" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="credit_code">
                    <el-input v-model="editForm.credit_code" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="公司类型" prop="address_type">
                    <el-input v-model="editForm.address_type" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="公司注册时间" prop="established">
                    <el-input v-model="editForm.established" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" prop="company_address">
                    <el-input v-model="editForm.company_address" style="width:660px"></el-input>
                </el-form-item>
                <el-form-item label="法人代表姓名" prop="legal_person">
                    <el-input v-model="editForm.legal_person" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="法人代表身份证" prop="identification">
                    <el-input v-model="editForm.identification" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="userTel">
                    <el-input v-model="editForm.userTel" class="input1"></el-input>
                </el-form-item>
                <el-form-item label="支付金额" prop="pay">
                    <span>{{ editForm.pay }}</span>
                </el-form-item>
                <el-form-item label="已选印章">
                    <el-table style="width:650px" :data="sealTabeldata">
                        <el-table-column label="印章类型" prop="chapter_type"></el-table-column>
                        <el-table-column label="印章材质" prop="chapter_material"></el-table-column>
                        <el-table-column label="印章形状" prop="chapter_shape"></el-table-column>
                        <el-table-column label="印章价格" prop="chapter_price"></el-table-column>
                        <el-table-column label="印章数量" prop="chapter_num"></el-table-column>
                    </el-table>
                </el-form-item>
                <!-- <el-form-item label="领取时间" prop="collection_time">
                    <el-input v-model="editForm.collection_time" class="input1"></el-input>
                </el-form-item> -->
                <el-form-item label="是否需要发票" prop="invoice">
                    <el-select v-model="editForm.invoice" style="width:180px">
                        <el-option v-for="item in needlist" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请理由" prop="application">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="editForm.application"
                        maxlength="100"
                        show-word-limit
                        style="width:660px"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="申请区域" prop="chapter_address">
                    <el-input v-model="editForm.chapter_address" style="width:660px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input type="textarea" v-model="editForm.note" style="width:660px"></el-input>
                </el-form-item>
                <el-form-item label="收件人" prop="recipient" v-if="editForm.chapter_address === '其他'">
                    <el-input v-model="editForm.recipient" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话" prop="contact" v-if="editForm.chapter_address === '其他'">
                    <el-input v-model="editForm.contact" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item label="省" prop="province" v-if="editForm.chapter_address === '其他'">
                    <el-select v-model="editForm.province" style="width:180px" @change="findcity()" filterable>
                        <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="40px" label="市" prop="city" v-if="editForm.chapter_address === '其他'">
                    <el-select v-model="editForm.city" style="width:190px" filterable @change="findcity()">
                        <el-option v-for="item in options[cityindex].children" :key="item.label" :label="item.label" :value="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="40px" label="区" prop="area" v-if="editForm.chapter_address === '其他'">
                    <el-select v-model="editForm.area" style="width:190px" filterable>
                        <el-option
                            v-for="item in options[cityindex].children[areaindex].children"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址" prop="recipient_address" v-if="editForm.chapter_address === '其他'">
                    <el-input v-model="editForm.recipient_address" style="width:420px"></el-input>
                </el-form-item>
                <el-form-item label-width="80px" label="邮编" prop="postcode" v-if="editForm.chapter_address === '其他'">
                    <el-input v-model="editForm.postcode" style="width:150px"></el-input>
                </el-form-item>
                <el-form-item label="申请状态" prop="status">
                    <el-select v-model="editForm.status" style="width:200px" filterable>
                        <el-option v-for="item in statuslist" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="填写印章编号" :visible.sync="fillsealnumber" width="900px">
            <el-table style="width:900px" :data="sealTabeldata">
                <el-table-column label="印章类型" prop="chapter_type" align="center"></el-table-column>
                <el-table-column label="印章材质" prop="chapter_material" align="center"></el-table-column>
                <el-table-column label="印章形状" prop="chapter_shape" align="center"></el-table-column>
                <el-table-column label="印章价格" prop="chapter_price" align="center"></el-table-column>
                <el-table-column label="印章数量" prop="chapter_num" align="center"></el-table-column>
                <el-table-column label="印章编号" prop="chapter_numbering" width="200px" align="center">
                    <template slot-scope="scope">
                        <input v-model="scope.row.chapter_numbering" style="width:150px" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="saveNumEdit(scope.$index, scope.row)">确认修改 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="退款处理" :visible.sync="tuikuanVisiable" width="300px">
            <el-button type="success" @click="aggreTuitkuan('7')">同意</el-button>
            <el-button type="danger" @click="aggreTuitkuan('6')">拒绝退款</el-button>
        </el-dialog>
        <el-dialog title="导出报表" :visible.sync="exportTableVisiable" width="600px">
            <el-form :model="exportTable" ref="exportTable" label-width="130px" inline="">
                <el-form-item label="时间筛选：">
                    <el-radio-group v-model="exportTable.TimeRadio">
                        <el-radio :label="0">订单申请</el-radio>
                        <el-radio :label="1">订单付款</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="订单申请时间：" v-if="exportTable.TimeRadio != 1">
                    <el-date-picker
                        class="data"
                        type="date"
                        placeholder="起始日期"
                        v-model="exportTable.start_time"
                        style="width: 150px;padding-right:5px"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <span>-</span>
                    <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="data"
                        type="date"
                        placeholder="结束日期"
                        v-model="exportTable.end_time"
                        style="width: 150px;padding-right:10px;padding-left:5px"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="订单付款时间：" v-else>
                    <el-date-picker
                        class="data"
                        type="date"
                        placeholder="起始日期"
                        v-model="exportTable.start_time"
                        style="width: 150px;padding-right:5px"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <span>-</span>
                    <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="data"
                        type="date"
                        placeholder="结束日期"
                        v-model="exportTable.end_time"
                        style="width: 150px;padding-right:10px;padding-left:5px"
                    >
                    </el-date-picker>
                </el-form-item>
                <p style="margin-left:20px;color:red">tips:(1)不输入日期可导出所有订单数据</p>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportTableVisiable = false">取 消</el-button>
                <el-button type="primary" @click="exportTableFun()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="价格修改" :visible.sync="editPriceVisiable" width="500px">
            <el-form ref="editPriceForm" :rules="rules1" :model="editPriceForm" label-width="120px">
                <el-form-item prop="numbering" label="单号">
                    {{ editPriceForm.numbering }}
                </el-form-item>
                <el-form-item prop="total" label="订单金额(元)">
                    {{ editPriceForm.total }}
                </el-form-item>
                <el-form-item label="修改价格(元)" prop="price">
                    <el-input v-model="editPriceForm.price"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editPriceVisiable = false">取 消</el-button>
                <el-button type="primary" @click="saveEditPrice()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="申请材料"
            :visible.sync="applyDocVisiable"
            width="1200px"
            @close="reset()"
            v-if="applyDocVisiable"
            v-loading="loading"
        >
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="120px" :inline="true">
                <div>
                    <el-button type="primary" @click="downloadAll()" style="margin-bottom:20px">一键下载</el-button>
                </div>
                <el-form-item label="营业执照" prop="license">
                    <img style="width:250px;heigth:450px" :src="editForm.license" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.license, '营业执照')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="正面照片" prop="since_photo">
                    <img style="width:250px;heigth:450px" :src="editForm.since_photo" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.since_photo, '正面照片')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="身份证正面照" prop="idcard_positive">
                    <img style="width:250px;heigth:300px" :src="editForm.idcard_positive" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.idcard_positive, '身份证正面照')">下载 </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="身份证反面照" prop="idcard_back">
                    <img style="width:250px;heigth:300px" :src="editForm.idcard_back" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.idcard_back, '身份证反面照')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="身份证正反面照" prop="idcard_back">
                    <img style="width:250px;heigth:300px" :src="picBackPositive" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(picBackPositive, '身份证正反面照')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="申请登记表" prop="apply" v-if="editForm.apply != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.apply" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.apply, '申请登记表')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="毁坏登记表" prop="destruction" v-if="editForm.destruction != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.destruction" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.destruction, '毁坏登记表')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="遗失承诺表" prop="lost" v-if="editForm.lost != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.lost" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.lost, '遗失承诺表')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="介绍信" prop="introduce" v-if="editForm.introduce != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.introduce" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.introduce, '介绍信')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="准予通知书" prop="advice" v-if="editForm.advice != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.advice" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.advice, '准予通知书')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="报纸抬头图片" prop="newspaper" v-if="editForm.newspaper != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.newspaper" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.newspaper, '报纸抬头图片')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="遗失声明图片" prop="statement" v-if="editForm.statement != ''">
                    <img style="width:250px;heigth:350px" :src="editForm.statement" alt="" />
                    <div>
                        <el-button type="warning" @click="downloadCodeImg(editForm.statement, '遗失声明图片')">下载</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="其他" prop="license" v-if="editForm.picarr[0]">
                    <div v-for="(item, index) in editForm.picarr" :key="index">
                        <img style="width:250px;heigth:450px" :src="item.img" alt="" />
                        <div>
                            <el-button type="warning" @click="downloadCodeImg(item.img, '其他材料')">下载</el-button>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { post, get } from '../../../api/request';
import { regionData } from 'element-china-area-data';
import { timeChange } from '../../../api/function.js';
export default {
    name: 'basetable',
    data() {
        var price = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/;
            if (!value) {
                callback(new Error('请输入价格'));
            } else if (!Number(value)) {
                callback(new Error('请输入数字值'));
            } else if (value <= 0) {
                callback(new Error('请输入大于0元的价格'));
            } else {
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('小数点后最多只能输入两位'));
                }
            }
        };
        return {
            dateTime: '',
            comyname: '',
            loading: false,
            payTime: {
                start_time: '',
                end_time: ''
            },
            exportTable: {
                start_time: '',
                end_time: '',
                TimeRadio: 0
            },
            exportTableVisiable: false,
            picBackPositive: '',
            editPriceForm: {
                numbering: '',
                total: '',
                price: ''
            },
            editPriceNum: '',
            applyDocVisiable: false,
            cailiaoVisiable: false,
            tableData1: [],
            tuikuanNum: '', //退款订单号
            printData: {
                company_name: ''
            },
            number: '',
            needlist: [
                {
                    id: 'true',
                    label: '需要'
                },
                {
                    id: 'false',
                    label: '不需要'
                }
            ],
            statuslist: [
                {
                    label: '待付款',
                    id: '1'
                },
                {
                    label: '已受理',
                    id: '2'
                },
                {
                    label: '待确认',
                    id: '3'
                },
                {
                    label: '已完成',
                    id: '4'
                },
                {
                    label: '申请退款',
                    id: '5'
                },
                {
                    label: '退款失败',
                    id: '6'
                },
                {
                    label: '已退款',
                    id: '7'
                }
            ],
            cityindex: 0,
            areaindex: 0,
            options: regionData,
            sealTabeldata: [],
            companyid: '', //当前公司id
            //搜索数据
            tableData: [],
            query: {
                company_name: '',
                company_address: '',
                credit_code: '',
                legal_person: '',
                identification: '',
                userTel: '',
                address_type: '',
                status: '',
                start_time: '',
                end_time: '',
                pageIndex: 1,
                pageSize: 8,
                pay_time: '',
                remark: '',
                recipient: ''
            },
            pageTotal: 0,
            //添加数据
            addVisiable: false,
            addForm: {
                shape: ''
            },
            //编辑数据
            editVisible: false,
            editForm: {},
            rules1: {
                price: [
                    {
                        required: true,
                        validator: price,
                        trigger: 'blur'
                    }
                ]
            },
            //添加数据表单验证
            rules: {
                shape: [
                    {
                        required: true,
                        message: '请输入公章形状',
                        trigger: 'blur'
                    }
                ],
                application: [
                    {
                        required: true,
                        message: '请输入申请理由',
                        trigger: 'blur'
                    }
                ],
                company_name: [
                    {
                        required: true,
                        message: '请输入公司名称',
                        trigger: 'blur'
                    }
                ],
                company_address: [
                    {
                        required: true,
                        message: '请输入公司地址',
                        trigger: 'blur'
                    }
                ],
                address_type: [
                    {
                        required: true,
                        message: '请输入公司类型',
                        trigger: 'blur'
                    }
                ],
                established: [
                    {
                        required: true,
                        message: '请输入成立时间',
                        trigger: 'blur'
                    }
                ],
                credit_code: [
                    {
                        required: true,
                        message: '请输入统一社会信用代码',
                        trigger: 'blur'
                    }
                ],
                contact: [
                    {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                    }
                ],
                chapter_address: [
                    {
                        required: true,
                        message: '请输入申请区域',
                        trigger: 'blur'
                    }
                ],
                recipient: [
                    {
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur'
                    }
                ],
                contact: [
                    {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                    }
                ],
                province: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }
                ],
                city: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }
                ],
                area: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }
                ],
                recipient_address: [
                    {
                        required: true,
                        message: '请输入详细地址',
                        trigger: 'blur'
                    }
                ],
                postcode: [
                    {
                        required: true,
                        message: '请输入邮编',
                        trigger: 'blur'
                    }
                ],
                collection_time: [
                    {
                        required: true,
                        message: '请输入领取时间',
                        trigger: 'blur'
                    }
                ],
                legal_person: [
                    {
                        required: true,
                        message: '请输入法人姓名',
                        trigger: 'blur'
                    }
                ],
                identification: [
                    {
                        required: true,
                        message: '请输入法人身份证',
                        trigger: 'blur'
                    }
                ],
                total: [
                    {
                        required: true,
                        message: '请输入支付金额',
                        trigger: 'blur'
                    }
                ],
                status: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }
                ],
                invoice: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }
                ]
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1,
            fillsealnumber: false,
            rownumbering: '',
            tuikuanVisiable: false, //,
            editPriceVisiable: false,
            pay_sum: null,
            paysumloding: false
        };
    },
    created() {
        this.companyid = sessionStorage.getItem('companyid');
        this.getData();
        this.getPrint();
    },
    activated() {
        this.companyid = sessionStorage.getItem('companyid');
        //
        let formData = new FormData();
        formData.append('company_id', this.companyid);
        post('backstage/Chaptertrear/delunread ', formData).then(res => {
            this.$store.commit('setIsActive', 0);
        });
        this.getData();
        this.getPrint();
    },
    methods: {
        getcomyname(type, name) {
            let formdata = new FormData();
            formdata.append('id', name);
            formdata.append('type', type);
            post('backstage/Chaptertrear/getcomyname', formdata).then(res => {
                if (type == 1) {
                    this.comyname = res.data.data.company;
                } else {
                    this.comyname = res.data.data.company_name;
                }
            });
        },
        reset() {
            console.log(1111);
            console.log(this.editForm);
            this.editForm = {};
        },
        exportTableFun() {
            let formdata = new FormData();
            formdata.append('company_id', this.companyid);
            formdata.append('start_app', this.exportTable.start_time);
            formdata.append('end_app', this.exportTable.end_time);
            if (this.exportTable.TimeRadio == 1) {
                formdata.append('pay_time', 1);
            } else {
                // formdata.append('pay_time', '')
            }

            formdata.append('limit',1);
            post('/backstage/Chaptertrear/select', formdata).then(res => {
                if (res.data.data.num != 0) {
                    window.location.href = `https://cs.huayeyun.cn/backstage/Chaptertrear/export?start_app=${
                        this.exportTable.start_time
                    }&end_app=${this.exportTable.end_time}&pay_time=${this.exportTable.TimeRadio == 1 ? 1 : 0}`;

                    this.$message.success('导出成功');
                    this.exportTableVisiable = false;
                    this.exportTable.start_time = '';
                    this.exportTable.end_time = '';
                } else {
                    this.$message.error('该日期范围内无数据');
                }
            });
        },
        editPrice(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editPriceForm.total = this.editForm.pay;
            this.editPriceForm.numbering = this.editForm.numbering;
            this.editPriceVisiable = true;
        },
        saveEditPrice() {
            this.$refs['editPriceForm'].validate(valid => {
                if (valid) {
                    let formdata = new FormData();
                    formdata.append('numbering', this.editPriceForm.numbering);
                    formdata.append('pay', this.editPriceForm.price);
                    post('backstage/Chaptertrear/updrealpay', formdata).then(res => {
                        if (res.data.msg == '修改成功') {
                            this.$message.success('修改成功');
                            this.getData();
                            this.editPriceVisiable = false;
                        }
                    });
                }
            });
        },
        downloadAll() {
            fetch(this.editForm.license)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '营业执照';
                    document.body.appendChild(link);
                    link.click();
                });
            fetch(this.editForm.idcard_positive)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '身份证正面';
                    document.body.appendChild(link);
                    link.click();
                });
            fetch(this.editForm.idcard_back)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '身份证反面';
                    document.body.appendChild(link);
                    link.click();
                });
            fetch(this.editForm.since_photo)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '正面照片';
                    document.body.appendChild(link);
                    link.click();
                });
            fetch(this.picBackPositive)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '身份证正反面';
                    document.body.appendChild(link);
                    link.click();
                });
            if (this.editForm.apply != '') {
                fetch(this.editForm.apply)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '申请登记表';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.destruction != '') {
                console.log(this.editForm.destruction);
                fetch(this.editForm.destruction)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '毁坏登记表';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.lost != '') {
                fetch(this.editForm.lost)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '遗失承诺表';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.introduce != '') {
                fetch(this.editForm.introduce)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '介绍信';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.advice != '') {
                fetch(this.editForm.advice)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '准予通知书';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.newspaper != '') {
                fetch(this.editForm.newspaper)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '报纸抬头图片';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            if (this.editForm.statement != '') {
                fetch(this.editForm.statement)
                    .then(res => res.blob())
                    .then(blob => {
                        // 将链接地址字符内容转变成blob地址
                        let link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        console.log(link.href);
                        link.download = '遗失声明图片';
                        document.body.appendChild(link);
                        link.click();
                    });
            }
            // this.getUrlBase64(this.editForm.license).then(base64 => {
            //     let link = document.createElement('a')
            //     link.href = base64
            //     link.download = "营业执照"
            //     link.click()
            // })
            // this.getUrlBase64(this.editForm.idcard_positive).then(base64 => {
            //     let link = document.createElement('a')
            //     link.href = base64
            //     link.download = "身份证正面"
            //     link.click()
            // })
            // this.getUrlBase64(this.editForm.idcard_back).then(base64 => {
            //     let link = document.createElement('a')
            //     link.href = base64
            //     link.download = "身份证反面"
            //     link.click()
            // })
            // this.getUrlBase64(this.editForm.since_photo).then(base64 => {
            //     let link = document.createElement('a')
            //     link.href = base64
            //     link.download = "正面照片"
            //     link.click()
            // })
            // this.getUrlBase64(this.picBackPositive).then(base64 => {
            //     let link = document.createElement('a')
            //     link.href = base64
            //     link.download = "身份证正反面"
            //     link.click()
            // })
            // if (this.editForm.apply != "") {
            //     this.getUrlBase64(this.editForm.apply).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "申请登记表"
            //         link.click()
            //     })
            // }
            // if (this.editForm.destruciton != "") {
            //     this.getUrlBase64(this.editForm.destruciton).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "毁坏登记表"
            //         link.click()
            //     })
            // }
            // if (this.editForm.lost != "") {
            //     this.getUrlBase64(this.editForm.lost).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "遗失承诺表"
            //         link.click()
            //     })
            // }
            // if (this.editForm.introduce != "") {
            //     this.getUrlBase64(this.editForm.introduce).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "介绍信"
            //         link.click()
            //     })
            // }
            // if (this.editForm.advice != "") {
            //     this.getUrlBase64(this.editForm.advice).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "准予通知书"
            //         link.click()
            //     })
            // }
            // if (this.editForm.newspaper != "") {
            //     this.getUrlBase64(this.editForm.newspaper).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "报纸抬头图片"
            //         link.click()
            //     })
            // }
            // if (this.editForm.statement != "") {
            //     this.getUrlBase64(this.editForm.statement).then(base64 => {
            //         let link = document.createElement('a')
            //         link.href = base64
            //         link.download = "遗失声明图片"
            //         link.click()
            //     })
            // }
        },
        getUrlBase64(url) {
            return new Promise(resolve => {
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                let img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.src = url + '?time=' + new Date().valueOf();
                img.onload = function() {
                    (canvas.height = img.height), (canvas.width = img.width);
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    let dataURL = canvas.toDataURL('image/png');
                    canvas = null;
                    resolve(dataURL);
                };
            });
        },
        downloadCodeImg(url, name, width, height) {
            let link = document.createElement('a');

            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    // 将链接地址字符内容转变成blob地址
                    link.href = URL.createObjectURL(blob);
                    console.log(link.href);
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();
                });
        },
        getPrint() {
            let formdata = new FormData();
            formdata.append('company_id', this.companyid);
            post('admin/set/selectset', formdata).then(res => {
                if (res.data.data.set[0]) {
                    this.printData = res.data.data.set[0];
                }
            });
        },
        lookCailiao(index, row) {
            this.tableData1 = [
                {
                    apply: '',
                    lost: '',
                    destruciton: '',
                    introduce: '',
                    advice: '',
                    newspaper: '',
                    statement: ''
                }
            ];
            this.tableData1[0].apply = row.apply;
            this.tableData1[0].lost = row.lost;
            this.tableData1[0].destruciton = row.destruciton;
            this.tableData1[0].introduce = row.introduce;
            this.tableData1[0].advice = row.advice;
            this.tableData1[0].newspaper = row.newspaper;
            this.tableData1[0].statement = row.statement;
            console.log(this.tableData1);
            this.cailiaoVisiable = true;
        },
        saveNumEdit(index, row) {
            let formdata = new FormData();
            formdata.append('id', row.id);
            formdata.append('chapter_numbering', row.chapter_numbering);
            post('backstage/Chaptertrear/updatenum', formdata).then(res => {
                if (res.data.msg == '修改成功') {
                    this.$message.success('修改成功');
                }
            });
        },
        sealnumber(index, row) {
            this.fillsealnumber = true;
            let formdata = new FormData();
            formdata.append('numbering', row.numbering);
            this.rownumbering = row.numbering;
            post('/backstage/Chaptertrear/sealnum', formdata).then(res => {
                this.sealTabeldata = res.data.data;
            });
        },
        tuikuan(index, row) {
            this.tuikuanVisiable = true;
            this.tuikuanNum = row.numbering;
        },
        aggreTuitkuan(state) {
            let formdata = new FormData();
            formdata.append('numbering', this.tuikuanNum);
            formdata.append('status', state);
            console.log(state);
            post('api/Pay/submitDrawBack', formdata).then(res => {
                if (res.data.msg == '修改成功') {
                    this.tuikuanVisiable = false;
                    this.$message.error('退款失败');
                } else if (res.data.message == '基本账户余额不足，请充值后重新发起') {
                    this.$message.warning('账户余额不足');
                } else {
                    this.tuikuanVisiable = false;
                    this.$message.success('退款成功');
                }

                this.getData();
            });
        },
        sendGoods(index, row) {
            this.$confirm('确认发货', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData();
                    formdata.append('numbering', row.numbering);
                    post('backstage/Chaptertrear/updstatus', formdata).then(res => {
                        if (res.data.msg == '修改成功') {
                            this.$message.success('发货成功');
                        }
                        this.getData();
                    });
                })
                .catch(() => {});
        },
        findcity() {
            for (let i = 0; i < this.options.length; i++) {
                if (this.editForm.province == this.options[i].label) {
                    this.cityindex = i;
                }
            }
            for (let i = 0; i < this.options[this.cityindex].children.length; i++) {
                if (this.editForm.city == this.options[this.cityindex].children[i].label) {
                    this.areaindex = i;
                }
            }
        },
        preview() {
            let htmlStr = document.getElementById('printme');
            let newWin = window.open(''); //新打开一个空窗口
            newWin.document.body.append(htmlStr); // 打印内容
            newWin.document.close(); //在IE浏览器中使用必须添加这一句
            newWin.focus(); //在IE浏览器中使用必须添加这一
            setTimeout(function() {
                newWin.print(); //打印
                newWin.close(); //关闭窗口
                window.location.reload();
            }, 100);
        },
        printwindow(index, row) {
            this.dateTime = timeChange(new Date());
            this.idx = index;
            this.addForm = Object.assign({}, row);
            this.addVisiable = true;
            let formdata = new FormData();
            formdata.append('numbering', this.addForm.numbering);
            post('/backstage/Chaptertrear/sealnum', formdata).then(res => {
                this.sealTabeldata = res.data.data;
            });
        },
        updateStatus(index, row) {
            let formdata = new FormData();
            let url = 'admin/admin_user/disables';
            formdata.append('id', row.id);
            if (row.disable == 1) {
                url = 'admin/admin_user/starts';
            }
            post(url, formdata).then(res => {
                if (res.data.msg == '禁用失败') {
                    this.$message.error('禁用失败');
                } else if (res.data.msg == '禁用成功') {
                    this.$message.success('禁用成功');
                    this.getData();
                } else if (res.data.msg == '启用成功') {
                    this.$message.success('启用成功');
                    this.getData();
                } else if (res.data.msg == '启用失败') {
                    this.$message.error('启用失败');
                    this.getData();
                }
            });
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch() {
            this.query.pageIndex = 1;
            this.query.company_name = '';
            this.query.company_address = '';
            this.query.credit_code = '';
            this.query.redit_code = '';
            this.query.legal_person = '';
            this.query.userTel = '';
            this.query.identification = '';
            this.query.contact = '';
            this.query.address_type = '';
            this.query.status = '';
            this.query.start_time = '';
            this.query.end_time = '';
            this.query.page_time = '';
            this.payTime.start_time = '';
            this.payTime.end_time = '';
            this.getData();
        },
        // 获取后端接口数据
        getData() {
            console.log(this.query.status);
            let formdata = new FormData();
            let pay_time = false;
            if (
                (this.payTime.start_time == '' || this.payTime.start_time == null) &&
                (this.payTime.end_time == '' || this.payTime.start_time == null)
            ) {
                pay_time = false;
            } else {
                pay_time = true;
            }

            if (this.query.start_time == null) {
                this.query.start_time = '';
            }
            if (this.query.end_time == null) {
                this.query.end_time = '';
            }
            if (this.payTime.start_time == null) {
                this.payTime.start_time = '';
            }
            if (this.payTime.end_time == null) {
                this.payTime.end_time = '';
            }

            if (pay_time) {
                formdata.append('page', this.query.pageIndex);
                formdata.append('limit', this.query.pageSize);
                formdata.append('company_id', this.companyid);
                formdata.append('company_name', this.query.company_name);
                formdata.append('company_address', this.query.company_address);
                formdata.append('legal_person', this.query.legal_person);
                formdata.append('remark', this.query.remark);
                formdata.append('identification', this.query.identification);
                formdata.append('contact', this.query.userTel);
                formdata.append('credit_code', this.query.credit_code);
                formdata.append('address_type', this.query.address_type);
                formdata.append('status', this.query.status);
                formdata.append('start_app', this.payTime.start_time);
                formdata.append('end_app', this.payTime.end_time);
                formdata.append('recipient', this.query.recipient);
                formdata.append('pay_time', 1);
            } else {
                formdata.append('page', this.query.pageIndex);
                formdata.append('limit', this.query.pageSize);
                formdata.append('company_id', this.companyid);
                formdata.append('company_name', this.query.company_name);
                formdata.append('company_address', this.query.company_address);
                formdata.append('remark', this.query.remark);
                formdata.append('legal_person', this.query.legal_person);
                formdata.append('identification', this.query.identification);
                formdata.append('contact', this.query.userTel);
                formdata.append('credit_code', this.query.credit_code);
                formdata.append('address_type', this.query.address_type);
                formdata.append('status', this.query.status);
                formdata.append('recipient', this.query.recipient);
                formdata.append('start_app', this.query.start_time);
                formdata.append('end_app', this.query.end_time);
                formdata.append('pay_time', '');
            }

            post('/backstage/Chaptertrear/select', formdata).then(res => {
                if ((res.code = 200)) {
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num;
                    if (res.data.data.sum != undefined && res.data.data.sum != null) {
                        this.pay_sum = res.data.data.sum;
                        this.paysumloding = true;
                    } else {
                        this.paysumloding = false;
                    }

                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData();
                    }
                } else {
                    this.$message.error('暂无数据');
                    this.paysumloding = false;
                }
            });
        },
        // 触发搜索按钮
        inputSearch() {
            let formdata = new FormData();
            let pay_time = false;
            if (
                (this.payTime.start_time == '' || this.payTime.start_time == null) &&
                (this.payTime.end_time == '' || this.payTime.start_time == null)
            ) {
                pay_time = false;
            } else {
                pay_time = true;
            }
            // formData传null会变为字符串格式
            if (this.query.start_time == null) {
                this.query.start_time = '';
            }
            if (this.query.end_time == null) {
                this.query.end_time = '';
            }
            if (this.payTime.start_time == null) {
                this.payTime.start_time = '';
            }
            if (this.payTime.end_time == null) {
                this.payTime.end_time = '';
            }

            if (pay_time) {
                formdata.append('page', this.query.pageIndex);
                formdata.append('limit', this.query.pageSize);
                formdata.append('company_id', this.companyid);
                formdata.append('company_name', this.query.company_name);
                formdata.append('company_address', this.query.company_address);
                formdata.append('legal_person', this.query.legal_person);
                formdata.append('identification', this.query.identification);
                formdata.append('contact', this.query.userTel);
                formdata.append('credit_code', this.query.credit_code);
                formdata.append('address_type', this.query.address_type);
                formdata.append('status', this.query.status);
                formdata.append('remark', this.query.remark);
                formdata.append('recipient', this.query.recipient);
                formdata.append('start_app', this.payTime.start_time);
                formdata.append('end_app', this.payTime.end_time);
                formdata.append('pay_time', 1);
            } else {
                formdata.append('page', this.query.pageIndex);
                formdata.append('limit', this.query.pageSize);
                formdata.append('company_id', this.companyid);
                formdata.append('company_name', this.query.company_name);
                formdata.append('company_address', this.query.company_address);
                formdata.append('legal_person', this.query.legal_person);
                formdata.append('identification', this.query.identification);
                formdata.append('contact', this.query.userTel);
                formdata.append('credit_code', this.query.credit_code);
                formdata.append('remark', this.query.remark);
                formdata.append('address_type', this.query.address_type);
                formdata.append('status', this.query.status);
                formdata.append('recipient', this.query.recipient);
                formdata.append('start_app', this.query.start_time);
                formdata.append('end_app', this.query.end_time);

                formdata.append('pay_time', '');
            }

            post('/backstage/Chaptertrear/select', formdata).then(res => {
                if ((res.code = 200)) {
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num;
                    if (res.data.data.sum != undefined && res.data.data.sum != null) {
                        this.pay_sum = res.data.data.sum;
                        this.paysumloding = true;
                    } else {
                        this.paysumloding = false;
                    }
                } else {
                    this.$message.error('暂无数据');
                    this.paysumloding = false;
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData();
                    formdata.append('numbering', row.numbering);
                    post('home/order/delorder', formdata).then(res => {
                        if (res.data.msg == '删除成功') {
                            this.$message.success('删除成功');
                            if (this.pageTotal / this.query.pageSize < this.query.pageIndex)
                                this.query.pageIndex = this.query.pageIndex - 1;
                            this.getData();
                        } else this.message.error('删除失败');
                    });
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
            let formdata = new FormData();
            formdata.append('numbering', this.editForm.numbering);
            post('/backstage/Chaptertrear/sealnum', formdata).then(res => {
                this.sealTabeldata = res.data.data;
                this.findcity();
            });
        },
        applyDoc(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);

            this.editForm.picarr = JSON.parse(this.editForm.picarr);
            console.log(this.editForm);
            this.applyDocVisiable = true;
            this.loading = true;
            let formdata = new FormData();
            formdata.append('numbering', row.numbering);
            post('chapter/Chaptering/positive_back', formdata).then(res => {
                this.picBackPositive = res.data;
                this.loading = false;
            });
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate(valid => {
                if (valid) {
                    let formdata = new FormData();
                    let ret = [];
                    ret.push(this.editForm);
                    var json = JSON.stringify(ret);
                    formdata.append('ret', json);
                    post('backstage/Chaptertrear/update', formdata).then(res => {
                        if (res.data.msg == '修改成功') {
                            this.getData();
                            this.$message.success('修改成功');
                            this.editVisible = false;
                        } else {
                            this.$message.error('修改失败');
                        }
                    });
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.iconPic {
    width: 25px;
    height: 25px;
    margin-left: 10px;
}

.iconPic1 {
    width: 27px;
    height: 27px;
    margin-left: 10px;
}

.input1 {
    width: 250px;
}

.titlename1 {
    width: 500px;
}

.titlename2 {
    width: 1000px;
}

.titlename3 {
    width: 2000px;
}

.table2 .tr1 {
    height: 40px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.table2 .tr2 {
    height: 220px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.table .tr1 {
    height: 40px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.table .tr2 {
    height: 250px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.handel-box {
    height: 400px;
}

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.codeline2 {
    margin-left: 30px;
}

.table1 {
    width: 100%;
    font-size: 14px;
}

.table2 {
    margin: auto;
    border: 1px solid #333;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.editor-btn {
    margin-top: 20px;
}

.typeEnter {
    overflow: hidden;
    width: 120px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.a4-endwise {
    width: 1075px;
    height: 1550px;
    overflow: hidden;
    padding: 0;
    word-break: break-all;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;
}

.a4-endwise1 {
    height: 1550px;
    width: 1075px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;
}

.title2 {
    margin-top: 30px;
    font-size: 38px;
    text-align: center;
    font-weight: bold;
}

.title {
    margin-top: 5px;
    font-size: 38px;
    text-align: center;
    font-weight: bold;
}

.p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.table {
    margin: 0 auto;
    border: 1px solid #333;
}

.table .tr {
    height: 42px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.table2 .tr {
    height: 42px;
    line-height: 45px;
    display: flex;
    font-size: 19px;
    border-bottom: 1px solid #333;
}

.titlename {
    width: 170px;
}

.br {
    border-right: 1px solid #333;
}

.tc {
    text-align: center;
}

.br {
    border-right: 1px solid #333;
}

.p_lr {
    padding: 0 10px;
}

.fl {
    flex: 1;
}

.listbox div {
    border-right: 1px solid #333;
    /* flex: 1; */
}

.listbox {
    text-align: center;
}

.listbox .goodslist {
    width: 170px;
}

.boxlist {
    height: 300px;
    border-bottom: 1px solid #333;
}

.df {
    display: flex;
}

.bottomline {
    font-size: 19px;
    margin-top: 10px;
}

.remarkbox {
    display: flex;
}

.top_title {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #333;
}

.ti_top {
    width: 100%;
    font-size: 21px;
}

.boxlist .boxlist_l {
    width: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
}

.boxlist_b {
    width: 100%;
    flex: 1;
    position: relative;
}

.reasonFn {
    padding-top: 10px;
}

.p_lr {
    padding: 0 10px;
}

.boxlist_bl {
    width: 100%;
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
}

.boxlist_bl p:last-child {
    text-align: right;
}

.boxlist_bl p {
    flex: 1;
}

.boxlist_bl p span {
    padding: 0 15px;
}

.remarkbox_l {
    width: 170px;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 50px;
}

.gangbi {
    float: right;
}

.div3 {
    transform: rotate(90deg);
}

.buttonBar {
    padding: 20px 0;
    display: flex;
    align-items: center;
}

.buttonBar div {
    display: inline-block;
}

.buttonBar .elTag {
    margin-left: 30px;
}
</style>
